// extracted by mini-css-extract-plugin
module.exports = {"card_footer":"EditProfileForm_card_footer__24STq","card_content":"EditProfileForm_card_content__3gFM6"};